<template>

  <section class="box-faq -bg-darkblue">
    <h1 class="maintitle">¿Quieres <b>solicitar</b> un crédito y necesitas <b>informarte</b>?</h1>
    <div class="container">
      <div class="row row-responsive">
        <div class="column column-sm-80 column-offset-sm-10">
          <h2 class="title">Top {{ faq.length }} FAQ's <b class="-green">solicitante</b></h2>
          <Tabs :content="faq"></Tabs>
        </div>
      </div>
    </div>
  </section>

</template>

<script>

import Tabs from '@/components/Tabs'

export default {
  name: 'FundingFaq',
  data () {
    return {
      faq: [
        {
          'id': 1,
          'title': '1. ¿Cuánto anticipan de la factura?',
          'text': '<p>En la mayoría de los casos se anticipa un 80%, pero esto depende del cliente. En el 100% de los casos se devuelven todos los excedentes.</p>'
        },
        {
          'id': 2,
          'title': '2. ¿Cuánto tiempo se tardan en dar el crédito?',
          'text': '<p>El financiamiento en Cumplo es muy rápido, después de entregar toda la información de manera correcta, puedes recibir tu dinero en alrededor de 7 días.</p>'
        },
        {
          'id': 3,
          'title': '3. ¿Cuál es el costo de comisión por apertura?',
          'text': '<p>En Cumplo no existe la comisión por apertura, sólo hay un único costo Cumplo.</p>'
        },
        {
          'id': 4,
          'title': '4. ¿Puede mejorar mi tasa de financiamiento?',
          'text': '<p>¡Claro! Cumplo premia tu buen comportamiento de pago con la reducción de la tasa en tus siguientes solicitudes. Mientras más créditos publiques, mayor confianza generarás a los inversionistas.</p>'
        },
        {
          'id': 5,
          'title': '5. ¿Por qué financiarme con Cumplo y no con un banco?',
          'text': '<p>Porque con Cumplo es más sencillo, existe mayor eficiencia en la operación, el fondeo de tu solicitud en la plataforma puede ser cuestión de días, no cobramos los intereses no devengados y tenemos como propósito general apoyarte con el crecimiento de tu empresa, para seguir impulsando el desarrollo de nuestro país.</p>'
        },
        {
          'id': 6,
          'title': '6. ¿Cuál es el costo por uso de plataforma?',
          'text': 'El costo por uso de la plataforma puede ir del 0.5% al 1.9% mensual para cualquiera de nuestros productos.'
        }
      ]
    }
  },
  components: {
    Tabs
  }
}

</script>

<style lang="scss" scoped>

.box-faq {
  padding: 10rem 0 6rem;
  margin-top: -30px;
  color: $white;

  .maintitle {
    margin-bottom: 5rem;
    font-size: 2.6em;
  }

  .title {
    font-weight: 300;
    text-align: center;
  }

}

.box-faq-answers {
  border: 1px solid $white;
  border-radius: 3px;

  > div:first-of-type .faq-title {
    border-top: 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/funding/FundingFaq.vue